/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

const BCPLogo = ({ height = 40, showText = true }) => {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main;
    const textColor = theme.palette.text.primary;

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
                '& svg': {
                    flexShrink: 0,
                },
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={height}
                height={height}
                viewBox="0 0 40 40"
                fill="none"
            >
                {/* Geometric icon representing technology/consulting */}
                <rect
                    x="4"
                    y="4"
                    width="14"
                    height="14"
                    rx="2"
                    fill={primaryColor}
                    opacity="0.9"
                />
                <rect
                    x="22"
                    y="4"
                    width="14"
                    height="14"
                    rx="2"
                    fill={primaryColor}
                />
                <rect
                    x="4"
                    y="22"
                    width="14"
                    height="14"
                    rx="2"
                    fill={primaryColor}
                    opacity="0.7"
                />
                <rect
                    x="22"
                    y="22"
                    width="14"
                    height="14"
                    rx="2"
                    fill={primaryColor}
                    opacity="0.5"
                />
                {/* Connecting lines for network/consulting feel */}
                <path
                    d="M18 11L22 11"
                    stroke={primaryColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M11 18L11 22"
                    stroke={primaryColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18 29L22 29"
                    stroke={primaryColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M29 18L29 22"
                    stroke={primaryColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </svg>
            {showText && (
                <Box
                    component="span"
                    sx={{
                        fontSize: '2rem',
                        fontWeight: 900,
                        letterSpacing: '0.1em',
                        color: textColor,
                        fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
                        textTransform: 'uppercase',
                        position: 'relative',
                        display: 'inline-block',
                        lineHeight: 1,
                        textShadow: `0 2px 8px ${primaryColor}20`,
                    }}
                >
                    BCP
                </Box>
            )}
        </Box>
    );
};

BCPLogo.propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showText: PropTypes.bool,
};

export default BCPLogo;

